"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmployeeDismissalsFormValidation = exports.EmployeeAssignmentValidationsV2 = exports.EmployeeAssignmentValidations = exports.EmployeeFamilyMemberValidations = exports.EmployeeTaxValidations = exports.EmployeeLanguagesFormValidation = exports.EmployeeTrainingsFormValidation = exports.EmployeeBankAccountValidations = exports.EmployeeContactInfoValidation = void 0;
const types_1 = require("api/references/employees/types");
const types_2 = require("api/documents/human-resources/assign-submissions/types");
const apiGlobalTypes_1 = require("api/types/apiGlobalTypes");
const validates_1 = require("core/helpers/validates");
const assignSubmissionItemForm_1 = require("src/modules/documents/hr/assign-submissions/validates/assignSubmissionItemForm");
const EmployeeContactInfoValidation = (values, translate) => {
    const formErrors = {
        firstname: (0, validates_1.required)(values.firstname, translate) || (0, validates_1.checkSymbolsAndNumbersGE)(values.firstname, translate),
        lastname: (0, validates_1.required)(values.lastname, translate) || (0, validates_1.checkSymbolsAndNumbersGE)(values.lastname, translate),
        firstnameLatin: (0, validates_1.checkSymbolsAndNumbersLA)(values.firstnameLatin, translate),
        lastnameLatin: (0, validates_1.checkSymbolsAndNumbersLA)(values.lastnameLatin, translate),
        identityNumber: values.foreignCitizen === types_1.Citizen.GEORGIAN
            || (values.foreignCitizen === types_1.Citizen.FOREIGN && (values.residenceCertificateEndDate || values.residenceCertificateNumber))
            ? (0, validates_1.requiredPersonalNumber)(values.identityNumber, translate) : undefined,
        passportNumber: values.foreignCitizen === types_1.Citizen.FOREIGN ? (0, validates_1.required)(values.passportNumber, translate) : undefined,
        passportValidTo: values.foreignCitizen === types_1.Citizen.FOREIGN ? (0, validates_1.required)(values.passportValidTo, translate) : undefined,
        residenceCertificateNumber: values.foreignCitizen !== types_1.Citizen.GEORGIAN
            ? values.residenceCertificateEndDate || (values.foreignCitizen === types_1.Citizen.FOREIGN && values.identityNumber)
                ? (0, validates_1.required)(values.residenceCertificateNumber, translate)
                : undefined
            : undefined,
        residenceCertificateEndDate: values.residenceCertificateNumber || (values.foreignCitizen === types_1.Citizen.FOREIGN && values.identityNumber)
            ? (0, validates_1.required)(values.residenceCertificateEndDate, translate)
            : undefined,
        country: values.foreignCitizen === types_1.Citizen.FOREIGN ? (0, validates_1.required)(values.country, translate) : undefined,
        administrativeBuilding: !values.noWorkPlace && values.administrativeBuildingRoom ? (0, validates_1.required)(values.administrativeBuilding, translate) : undefined
    };
    const errors = {};
    Object.entries(formErrors).forEach(([key, value]) => {
        if (value)
            errors[key] = value;
    });
    return errors;
};
exports.EmployeeContactInfoValidation = EmployeeContactInfoValidation;
const EmployeeBankAccountValidations = (values, translate) => {
    const formErrors = {
        bank: (0, validates_1.required)(values.bank, translate),
        accountNumber: (0, validates_1.required)(values.accountNumber, translate)
    };
    const errors = {};
    Object.entries(formErrors).map(([key, value]) => {
        if (value)
            errors[key] = value;
    });
    return errors;
};
exports.EmployeeBankAccountValidations = EmployeeBankAccountValidations;
const EmployeeTrainingsFormValidation = (values, translate) => {
    const formErrors = {
        name: (0, validates_1.required)(values.name, translate),
        dateFrom: (0, validates_1.required)(values.dateFrom, translate),
        fileUids: values.files.every(el => !el.id) ? translate('required_upload_file', 'სავალდებულო ფაილის ატვირთვა') : undefined
    };
    const errors = {};
    Object.entries(formErrors).forEach(([key, value]) => {
        if (value)
            errors[key] = value;
    });
    return errors;
};
exports.EmployeeTrainingsFormValidation = EmployeeTrainingsFormValidation;
const EmployeeLanguagesFormValidation = (values, translate) => {
    const formErrors = {
        language: (0, validates_1.required)(values.language, translate),
        level: (0, validates_1.required)(values.level, translate)
    };
    const errors = {};
    Object.entries(formErrors).forEach(([key, value]) => {
        if (value)
            errors[key] = value;
    });
    return errors;
};
exports.EmployeeLanguagesFormValidation = EmployeeLanguagesFormValidation;
const EmployeeTaxValidations = (values, translate) => {
    const formErrors = {
        taxReliefAmount: values.useOfTaxRelief ? (0, validates_1.required)(values.taxReliefAmount, translate) : undefined,
        errorTaxOptions: values.taxReliefBenefit === apiGlobalTypes_1.YesNoStatus.YES
            ? !values.taxReliefId ? 'სავალდებულოა, აირჩიოთ შეღავათის ტიპი' : undefined
            : undefined
    };
    const errors = {};
    Object.entries(formErrors).map(([key, value]) => {
        if (value)
            errors[key] = value;
    });
    return errors;
};
exports.EmployeeTaxValidations = EmployeeTaxValidations;
const EmployeeFamilyMemberValidations = (values, translate) => {
    const formErrors = {
        firstname: (0, validates_1.required)(values.firstname, translate),
        lastname: (0, validates_1.required)(values.lastname, translate),
        phone: (0, validates_1.required)(values.phone, translate)
    };
    const errors = {};
    Object.entries(formErrors).map(([key, value]) => {
        if (value)
            errors[key] = value;
    });
    return errors;
};
exports.EmployeeFamilyMemberValidations = EmployeeFamilyMemberValidations;
const EmployeeAssignmentValidations = (values, translate) => {
    const formErrors = {
        positionInfoErrors: values.positionInfos.map(positionInfo => {
            return {
                positionName: (0, validates_1.required)(positionInfo.positionName, translate),
                startDate: (0, validates_1.required)(positionInfo.startDate, translate)
            };
        })
    };
    const errors = {};
    Object.entries(formErrors).forEach(([key, value]) => {
        if (key !== 'positionInfoErrors' && value) {
            errors[key] = value;
        }
        else {
            formErrors.positionInfoErrors = formErrors.positionInfoErrors?.map(el => {
                if (el && (el.positionName || el.startDate)) {
                    return el;
                }
                return;
            });
            if (formErrors.positionInfoErrors.some(err => err)) {
                errors[key] = value;
            }
        }
    });
    return errors;
};
exports.EmployeeAssignmentValidations = EmployeeAssignmentValidations;
const EmployeeAssignmentValidationsV2 = (values, translate) => {
    const formErrors = {
        positionInfoErrors: values.positionInfos.map(positionInfo => {
            const workInfo = positionInfo.workInfo;
            return {
                positionName: (0, validates_1.required)(positionInfo.positionName, translate),
                startDate: (0, validates_1.required)(positionInfo.startDate, translate),
                project: workInfo.salaryType && Number(workInfo.salaryType.id) !== types_2.SalaryTypeV2.UNPAID
                    ? (0, validates_1.required)(positionInfo.workInfo.project, translate)
                    : undefined,
                workload: (0, validates_1.required)(workInfo.workload, translate),
                salaryType: (0, validates_1.required)(workInfo.salaryType, translate),
                salaryAmount: workInfo.salaryType && Number(workInfo.salaryType.id) === types_2.SalaryTypeV2.FIXED
                    ? (0, validates_1.requiredPositiveNumber)(workInfo.salaryAmount, translate)
                    : undefined,
                equivalentCurrency: workInfo.salaryType && Number(workInfo.salaryType.id) === types_2.SalaryTypeV2.FIXED && workInfo.isDifferentCurrency
                    ? (0, validates_1.required)(workInfo.equivalentCurrency, translate)
                    : undefined,
                currency: workInfo.salaryType && Number(workInfo.salaryType.id) === types_2.SalaryTypeV2.FIXED
                    ? (0, validates_1.required)(workInfo.currency, translate)
                    : undefined,
                remunerationWork: workInfo.salaryType && Number(workInfo.salaryType.id) === types_2.SalaryTypeV2.BY_JOB
                    ? (0, validates_1.required)(workInfo.remunerationWork, translate)
                    : undefined,
                workTypeInfoItems: workInfo.salaryType && Number(workInfo.salaryType.id) !== types_2.SalaryTypeV2.FIXED
                    ? Number(workInfo.salaryType.id) !== types_2.SalaryTypeV2.BY_JOB
                        ? (0, assignSubmissionItemForm_1.transformWorkInfoItemErrorsV2)(workInfo, positionInfo.startDate, positionInfo.endDate, translate)
                        : workInfo.remunerationWork ? (0, assignSubmissionItemForm_1.transformWorkInfoItemErrorsV2)(workInfo, positionInfo.startDate, positionInfo.endDate, translate) : []
                    : []
            };
        })
    };
    const errors = {};
    Object.entries(formErrors).forEach(([key, value]) => {
        if (key !== 'positionInfoErrors' && value) {
            errors[key] = value;
        }
        else {
            formErrors.positionInfoErrors = formErrors.positionInfoErrors?.map(el => {
                if (el && (el.positionName
                    || el.project
                    || el.workload
                    || el.salaryType
                    || el.salaryAmount
                    || el.equivalentCurrency
                    || el.currency
                    || el.remunerationWork
                    || (el?.workTypeInfoItems).some(workInfoItem => workInfoItem.salaryAmount
                        || workInfoItem.year
                        || workInfoItem.months
                        || workInfoItem.dateRange
                        || workInfoItem.currency
                        || workInfoItem.unitName
                        || workInfoItem.categoryOrder
                        || workInfoItem.tariff
                        || workInfoItem.administrativeOrdersArticle
                        || workInfoItem.volumeWorkPerformed
                        || workInfoItem.equivalentCurrency))) {
                    return el;
                }
                return;
            });
            if (formErrors.positionInfoErrors.some(err => err)) {
                errors[key] = value;
            }
        }
    });
    return errors;
};
exports.EmployeeAssignmentValidationsV2 = EmployeeAssignmentValidationsV2;
const EmployeeDismissalsFormValidation = (values, translate) => {
    const validReason = values.dismissalReason && (values.dismissalReason.id === String(types_1.DismissalReasonType.END_DATE)
        || values.dismissalReason.id === String(types_1.DismissalReasonType.JOB_PERFORMANCE)
        || values.dismissalReason.id === String(types_1.DismissalReasonType.VIOLATION_ETHIC_CODE)
        || values.dismissalReason.id === String(types_1.DismissalReasonType.OPTION_EXPIRATION)
        || values.dismissalReason.id === String(types_1.DismissalReasonType.AWARDING_EMERITUS));
    const formErrors = {
        assign: (0, validates_1.required)(values.assign, translate),
        dismissalReason: (0, validates_1.required)(values.dismissalReason, translate),
        dismissalDate: (0, validates_1.required)(values.dismissalDate, translate),
        documentNumber: validReason ? undefined : (0, validates_1.required)(values.documentNumber, translate),
        date: validReason ? undefined : (0, validates_1.required)(values.date, translate),
        title: validReason ? undefined : (0, validates_1.required)(values.title, translate)
    };
    const errors = {};
    Object.entries(formErrors).forEach(([key, value]) => {
        if (value)
            errors[key] = value;
    });
    return errors;
};
exports.EmployeeDismissalsFormValidation = EmployeeDismissalsFormValidation;
